function FindPartner(partners, target) {
  const partner = partners.find((x) => x.key === target)
  return {
    ...partner,
    title: window.AlpineI18n.t(`partners.${partner.translation}.title`),
    description: window.AlpineI18n.t(`partners.${partner.translation}.description`)
  }
}